export default "__VITE_ASSET__28c50aa0__"